module.exports = __webpack_public_path__ + "img/maleModel.183f141f.webp";